export class TreatmentActionModel {

    instruction: string;
    followed: boolean;

    constructor(instruction?: string, followed?: boolean) {
        if (instruction) {
            this.instruction = instruction.replace('•', '').trim();
            this.followed = followed;
        }
    }

}
